/**
 * US states and DC.
 *
 * Fifty-one rows is trivial to ship, so the state picker needs no backend.
 * `code` is the USPS abbreviation and doubles as the filename of that state's
 * county geometry under `static/maps/counties/`.
 */

const RAW = [
  ["Alabama", "AL", "south"],
  ["Alaska", "AK", "west"],
  ["Arizona", "AZ", "west"],
  ["Arkansas", "AR", "south"],
  ["California", "CA", "west"],
  ["Colorado", "CO", "west"],
  ["Connecticut", "CT", "northeast"],
  ["Delaware", "DE", "south"],
  ["District of Columbia", "DC", "south"],
  ["Florida", "FL", "south"],
  ["Georgia", "GA", "south"],
  ["Hawaii", "HI", "west"],
  ["Idaho", "ID", "west"],
  ["Illinois", "IL", "midwest"],
  ["Indiana", "IN", "midwest"],
  ["Iowa", "IA", "midwest"],
  ["Kansas", "KS", "midwest"],
  ["Kentucky", "KY", "south"],
  ["Louisiana", "LA", "south"],
  ["Maine", "ME", "northeast"],
  ["Maryland", "MD", "south"],
  ["Massachusetts", "MA", "northeast"],
  ["Michigan", "MI", "midwest"],
  ["Minnesota", "MN", "midwest"],
  ["Mississippi", "MS", "south"],
  ["Missouri", "MO", "midwest"],
  ["Montana", "MT", "west"],
  ["Nebraska", "NE", "midwest"],
  ["Nevada", "NV", "west"],
  ["New Hampshire", "NH", "northeast"],
  ["New Jersey", "NJ", "northeast"],
  ["New Mexico", "NM", "west"],
  ["New York", "NY", "northeast"],
  ["North Carolina", "NC", "south"],
  ["North Dakota", "ND", "midwest"],
  ["Ohio", "OH", "midwest"],
  ["Oklahoma", "OK", "south"],
  ["Oregon", "OR", "west"],
  ["Pennsylvania", "PA", "northeast"],
  ["Rhode Island", "RI", "northeast"],
  ["South Carolina", "SC", "south"],
  ["South Dakota", "SD", "midwest"],
  ["Tennessee", "TN", "south"],
  ["Texas", "TX", "south"],
  ["Utah", "UT", "west"],
  ["Vermont", "VT", "northeast"],
  ["Virginia", "VA", "south"],
  ["Washington", "WA", "west"],
  ["West Virginia", "WV", "south"],
  ["Wisconsin", "WI", "midwest"],
  ["Wyoming", "WY", "west"],
]

export const US_STATES = RAW.map(([name, code, region]) => ({ name, code, region }))

export const REGIONS = [
  { id: "all", label: "All" },
  { id: "northeast", label: "Northeast" },
  { id: "midwest", label: "Midwest" },
  { id: "south", label: "South" },
  { id: "west", label: "West" },
]

export function stateByCode(code) {
  const want = String(code || "").toUpperCase()
  return US_STATES.find(s => s.code === want)
}
